import Axios from "axios";
import md5 from "md5";
import { toast } from "react-toastify";
// Constants
import { WEB_SERVICE_MIMS } from "../config/constants";

// ----- State -----
const initialState = {
  isFetching: false,
  enteredAcrossLogin: false,
  data: {},
};

// ----- Types -----
// LOGIN
const CLINICIAN_LOGIN_STARTED = "CLINICIAN_LOGIN_STARTED";
const CLINICIAN_LOGIN_DONE = "CLINICIAN_LOGIN_DONE";
const CLINICIAN_LOGIN_ERROR = "CLINICIAN_LOGIN_ERROR";
// SET TOKEN
const CLINICIAN_VERIFY_TOKEN_DONE = "CLINICIAN_VERIFY_TOKEN_DONE";
const CLINICIAN_VERIFY_TOKEN_ERROR = "CLINICIAN_VERIFY_TOKEN_ERROR";
// LOGOUT
const CLINICIAN_LOGOUT = "CLINICIAN_LOGOUT";

// ----- Reducer -----
export default function reducer(state = initialState, action) {
  switch (action.type) {
    //CLINICIAN LOGIN
    case CLINICIAN_LOGIN_STARTED:
      return {
        ...state,
        isFetching: true,
      };
    case CLINICIAN_LOGIN_DONE:
      return {
        ...state,
        isFetching: false,
        enteredAcrossLogin: action.payload.enteredAcrossLogin,
        data: action.payload.data,
      };
    case CLINICIAN_LOGIN_ERROR:
      return {
        ...state,
        isFetching: false,
        enteredAcrossLogin: false,
        data: {},
      };
    //CLINICIAN VERIFY TOKEN
    case CLINICIAN_VERIFY_TOKEN_DONE:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
      };
    case CLINICIAN_VERIFY_TOKEN_ERROR:
      return {
        ...state,
        isFetching: false,
        enteredAcrossLogin: false,
        data: {},
      };
    //CLINICIAN LOGOUT
    case CLINICIAN_LOGOUT:
      return {
        ...state,
        isFetching: false,
        enteredAcrossLogin: false,
        data: {},
      };
    default:
      return state;
  }
}

// ----- Actions -----
// LOGIN
export const validateClinician =
  ({ user, password, errorMessage, isPasswordEncrypted = false, enteredAcrossLogin = false }) =>
  async (dispatch) => {
    dispatch({ type: CLINICIAN_LOGIN_STARTED });
    const encryptedPassword = isPasswordEncrypted ? password : password === "" ? "" : md5(`${user}${password}`);
    await Axios.post(`${WEB_SERVICE_MIMS}/login/clinician`, {
      CLINICIAN_USER: user,
      PASSWORD: encryptedPassword,
    })
      .then(({ data }) => {
        if (data.token) {
          dispatch({
            type: CLINICIAN_LOGIN_DONE,
            payload: {
              data,
              enteredAcrossLogin,
            },
          });
        } else {
          dispatch({
            type: CLINICIAN_LOGIN_ERROR,
          });
          return toast.error(errorMessage);
        }
      })
      .catch((error) => {
        console.log("url error: ", error);
        dispatch({
          type: CLINICIAN_LOGIN_ERROR,
        });
      });
  };

// SET TOKEN
export const successfulToken =
  ({ data }) =>
  (dispatch) => {
    dispatch({
      type: CLINICIAN_VERIFY_TOKEN_DONE,
      payload: {
        data,
      },
    });
  };

export const failedToken = () => (dispatch) => {
  dispatch({ type: CLINICIAN_VERIFY_TOKEN_ERROR });
};

//LOGOUT
export const clinicianLogout = () => (dispatch) => {
  dispatch({ type: CLINICIAN_LOGOUT });
};
